import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { languageswitchConstants } from '../constants';
import { SocialMediaListRender } from './SocialMediaListRender';


export const SocialMediaListCH = () => {
    const dispatch = useDispatch();
    const s = useSelector(state => state.socialmediaCH.socialmediaListCH);
    const [socialmediaListCH, setSocialmedialListCH] = useState(s);
    const loading = useSelector(state => state.socialmediaCH.loading);
    const e = useSelector(state => state.socialmediaCH.error);
    const [error, setError] = useState(e);
    const d = useSelector(state => state.socialmediaCH.done);
    const [done, setDone] = useState(d);
    var dataLimitPerPage = 15;

    const lang = useSelector(state => state.languageswitch);
    if (lang === languageswitchConstants.CHINESE_NR) {
        return <SocialMediaListRender
            stateList={s}
            socialmediaList={socialmediaListCH}
            setSocialmedialList={setSocialmedialListCH}
            loading={loading}
            errorState={e}
            error={error}
            setError={setError}
            doneState={d}
            done={done}
            setDone={setDone}
            dataLimitPerPage={dataLimitPerPage}
        />
    }
}